import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import { Calendar } from 'react-date-range';
import React, { useEffect, useRef, useState } from 'react';
import { Input, Button } from '@airdao/ui-library';
import { timestampToDate } from '../../utils/timestampToDate';
import useClickOutside from '../Select/useClickOutside';
import { timeToMilliseconds } from '../../utils/timeToMiliseconds';

type DatePickerProps = {
  value: any;
  onChange: (date: any) => void;
  minDate?: any;
  label?: string;
};

const DatePicker = ({ value, onChange, minDate, label }: DatePickerProps) => {
  const ref: any = useRef();
  const minutesInputRef: any = useRef();
  const hoursInputRef: any = useRef();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [timeShow, setTimeShow] = useState<boolean>(false);
  const [time, setTime] = useState<string>('');

  useClickOutside(
    ref,
    () => {
      setIsOpen(false);
      setTimeShow(false);
    },
    isOpen,
  );

  useEffect(() => {
    if (timeShow) {
      hoursInputRef.current.focus();
    }
  }, [timeShow]);

  const handleSelect = (date: any) => {
    onChange(date);
    setTimeShow(true);
  };

  const handleOpen = () => {
    setIsOpen(prevState => !prevState);
  };

  const handleHoursChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const hours = event.target.value;

    if (
      (/^\d+$/.test(hours) &&
        parseInt(hours) >= 0 &&
        parseInt(hours) <= 23 &&
        hours.length <= 2) ||
      !hours
    ) {
      setTime(`${hours}:${time.split(':')[1] || ''}`);
      if (hours.length === 2) {
        minutesInputRef.current.focus();
      }
    }
  };

  const handleMinutesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const minutes = event.target.value;
    if (
      (/^\d+$/.test(minutes) &&
        parseInt(minutes) >= 0 &&
        parseInt(minutes) <= 59 &&
        minutes.length <= 2) ||
      !minutes
    ) {
      setTime(`${time.split(':')[0] || ''}:${minutes}`);
    }
  };

  const addTime = () => {
    const ms = timeToMilliseconds(time);
    onChange(new Date(new Date(value).getTime() + ms));
    setTimeShow(false);
  };

  return (
    <div className="datepicker">
      <span className="create-bond__input-title">{label}</span>
      <div className="datepicker__input" onClick={handleOpen}>
        <Input
          value={value ? timestampToDate(value?.getTime() / 1000) : ''}
          placeholder="Select date"
        />
      </div>
      {isOpen && (
        <div className="datepicker__calendar" ref={ref}>
          {timeShow ? (
            <div className="timepicker">
              <div className="timepicker__input">
                <input
                  ref={hoursInputRef}
                  type="text"
                  value={time.split(':')[0] || ''}
                  onChange={handleHoursChange}
                />
                :
                <input
                  ref={minutesInputRef}
                  type="text"
                  value={time.split(':')[1] || ''}
                  onChange={handleMinutesChange}
                />
                <Button size="small" type="primary" onClick={addTime}>
                  Select
                </Button>
              </div>
            </div>
          ) : (
            <Calendar minDate={minDate} date={value} onChange={handleSelect} />
          )}
        </div>
      )}
    </div>
  );
};

export default DatePicker;
